export default __webpack_public_path__ + "static/media/linkedinColor.3fc86511.svg";